<template>
    <div class="recruitIndex">
        <div :style="{'background-image': 'url('+ RecruitBg +')'}" class="recruit-avatar">
            <div class="avatar-wrap">
                <img :src="avatarSrc" class="avatar-img" @error="avatarSrc = defaultAvatar" />
            </div>
            <div class="recruit-msg">
                <div class="msg-row-name">
                    <p class="msg-name">{{pageData.true_name || pageData.nickname || '-'}}</p>
                    <!-- 用户ID：用户表主键 id -->
                    <span class="msg-id" v-if="pageData.id">id：{{pageData.id}}</span>
                </div>
                <p class="msg-charge" v-if="pageData.level_name"><span v-if="pageData.is_staff == 1">【教职员工】</span>{{pageData.level_name || '-'}}</p>
                <p class="msg-referee" v-if="pageData.parent">推荐人：{{pageData.tParent || pageData.parent || '-'}}</p>
            </div>
        </div>
        <div class="recruit-count flex flex-a-i-center">
            <router-link :to="{name:'Achievement', query: {id: pageData.level}}">
                <img src="@/assets/recruit/student_icon_achievement@3x.png" class="count-img"/>
                <p class="count-title">我的业绩</p>
                <p class="count-num">{{pageData.total_price || '0.00'}}</p>
            </router-link>
            <router-link to="/Fans">
                <img src="@/assets/recruit/student_icon_fans@3x.png" class="count-img"/>
                <p class="count-title">我的粉丝</p>
                <p class="count-num">{{pageData.fans_amount || '0'}}</p>
            </router-link>
        </div>
        <div class="recruitFunc">
            <!-- 推广海报库 -->
            <div class="per-line" @click="targetPage({path:'/Source'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_spread@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">推广海报库</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 推广文章库 -->
            <div class="per-line" @click="targetPage({path:'/Notice/NoticeCard?type=article'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/artice.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">推广文章库</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的团队 -->
            <div class="per-line" @click="targetPage({path:'/Team',query:{level: pageData.level}})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_team@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">我的团队</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的学生 -->
            <!-- 入口只对职工开放：职工身份标识为 hjmallind_user.level = 3（不再用 is_staff） -->
            <div class="per-line" @click="targetPage({name:'Preview'})" v-if="pageData.level == 3">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/edit.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">我的学生</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 合伙人招募 -->
            <div class="per-line" @click="targetPage({path:'/InvitationCode', query:{type: pageData.level}})" v-if="pageData.level > 2">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_invite@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">合伙人招募</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 提现 -->
          <!--
            <div class="per-line" @click="targetPage({path:'/Cash'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_cash@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">奖金提现</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
             -->
            <!-- 问题答疑 -->
            <div class="per-line" @click="targetPage({path:'/Questions'})" v-if="pageData.is_staff == 1">
              <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center flex-j-c-center">
			            <img src="@/assets/recruit/student_icon_invite@3x.png" class="recruitFunc-icon"/>
			            <span class="recruitFunc-text">问题答疑</span>
                </div>
                <div class="flex flex-j-c-e method-right flex-a-i-center">
			            <img class="right-icon" src="@/assets/right.png">
                </div>
              </div>
          </div>
    </div>

        <div style="height:70px"></div>

        <Footer vals="tabRecruit" :vtext.sync="vtext"/>
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import {FuserMsg} from '@/api';
import { Toast, MessageBox } from 'mint-ui';

export default {
    name: 'RecruitIndex',
    components: {
      Footer
    },
    data() {
      return {
        RecruitBg: require('@/assets/recruit/student_bg@3x.png'), // 背景图
        defaultAvatar: require('@/assets/avatar.png'), // 头像加载失败时的兜底图
        avatarSrc: require('@/assets/avatar.png'), // 实际渲染的头像地址
        pageData: { avatar_url: require('@/assets/avatar.png'), }, // 页面数据
        sessionData: {}, // 缓存数据
        vtext: '0元上大学' // 底部bar文字
      }
    },
    watch:{
      // 头像地址变化时同步到渲染变量；为空或加载失败则退回默认头像
      'pageData.avatar_url': {
        immediate: true,
        handler(val) {
          this.avatarSrc = val || this.defaultAvatar;
        }
      }
    },
    created() {
      this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
      if (this.sessionData && this.sessionData.RecruitIndex) this.pageData = JSON.parse(this.sessionData.RecruitIndex);
      this.getUserMsg();
    },
    methods: {
      // 获取页面数据
      getUserMsg() {
        FuserMsg().then(res => {
          if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 2000}); }
          if (!this._tools.checkSData(res.data, 'RecruitIndex')) {
            this.pageData = res.data;
          }
          this.vtext = res.data.level == 1 ? '推荐有礼' : res.data.level == 2 ? '合伙人计划' : '0元上大学'
          if (res.data.level === -1) {
            MessageBox.alert('请先进行报名操作...').then(action => {
                this.$router.replace({name: 'HomePage'});
            });
          }
        })
      },
      // 合伙人（弃用）
      toInvitationCode() {
        if (this.pageData.level > 2) {
          this.$router.push({name:'InvitationCode', query:{type: this.pageData.level}})
        } else {
          Toast({message: '招生满三人，才有资格邀请助理招生人！请继续努力…', className: 'iconfont icon-close', duration: 2000});
        }
      },
      // 页面跳转
      targetPage(e) {
        this.$router.push(e);
      }
    }
}

</script>
<style lang='less' scoped>
.recruitIndex{
    min-height: 100vh;
    .recruit-avatar{
        width: 100%;
        height: 1.4rem;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        padding: 0 0.16rem;
        display: flex;
        align-items: center;

        .avatar-wrap{
            flex: 0 0 auto;
            width: 0.62rem;
            height: 0.62rem;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.25);
            margin-right: 0.13rem;
            box-shadow: 0 0.02rem 0.06rem rgba(126, 56, 0, 0.18);
        }
        .avatar-img{
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 0.02rem solid #fff;
            object-fit: cover;
            display: block;
            background: #fff;
        }
        .recruit-msg{
            flex: 1;
            min-width: 0;
            color: white;
            text-align: left;
            line-height: 0.22rem;

            .msg-row-name{
                display: flex;
                align-items: center;
                flex-wrap: wrap;
            }
            .msg-name{
                font-size: 0.175rem;
                font-weight: bold;
                line-height: 1.25;
                max-width: 1.9rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-shadow: 0 0.01rem 0.02rem rgba(126, 56, 0, 0.28);
            }
            // 用户ID：白色药丸 + 红色数字，放在昵称右侧
            .msg-id{
                margin-left: 0.07rem;
                font-size: 0.11rem;
                line-height: 0.17rem;
                height: 0.17rem;
                padding: 0 0.07rem;
                color: #fa5151;
                background: #fff;
                border-radius: 0.085rem;
                font-weight: 500;
                white-space: nowrap;
                box-shadow: 0 0.01rem 0.02rem rgba(126, 56, 0, 0.15);
            }
            .msg-charge, .msg-referee{
                font-size: 0.125rem;
                line-height: 1.45;
                margin-top: 0.03rem;
                opacity: 0.96;
            }
            .msg-referee{
                font-size: 0.12rem;
                opacity: 0.92;
            }
        }
    }
    .recruit-count{
        padding: 0.18rem 0;
        background: white;
        &>a{
            width: 50%;
        }
        P{
            margin-top: 0.02rem;
        }
        .count-img{
            width: 0.31rem;
            height: 0.31rem;
        }
        .count-title{
            font-size: 0.14rem;
            color: #333333;

        }
        .count-num{
            font-size: 0.15rem;
            color: #E01212;
            font-weight: bold;
        }
    }
    .recruitFunc{
        margin-top: 0.1rem;
        padding: 0 0.16rem;
        background: white;
        &>div:last-child{
            border: none;
        }
        .recruit-func{
            .recruitFunc-icon{
                width: 0.21rem;
                height: 0.21rem;
                margin-right: 0.08rem;
            }
            .recruitFunc-text{
                font-size: 0.16rem;
                color: #000000;
            }
        }
    }
}
</style>
